import React from 'react';

//Creates a Context Object
// Context object - is an object that can be used to store information that can be shared to other components within the app.
// Context object is a different approach to passing information between 
//components and it allows us to have easier access by avoiding the use of prop drilling.
const UserContext = React.createContext();

// The "Provider" components allows other components to consume/use the context object and supply the necessary information needed
//to the context object.
export const UserProvider = UserContext.Provider;

export default UserContext;

